export enum OutOfBandTransactionStatus {
  PAID = "PAID",
  PENDING_VALIDATION = "PENDING_VALIDATION",
  PAST_DUE = "PAST_DUE",
  CARD = "CARD",
  CHECK = "CHECK",
  CASH = "CASH",
  HIDDEN_PAST_DUE = "HIDDEN_PAST_DUE",
}
